import CityPageTemplate from "../city-template/CityPageTemplate";
import { presqueIsleConfig } from "./data";

export default function PresqueIslePage() {
  return <CityPageTemplate config={presqueIsleConfig} />;
}